var beEndPoint = process.env.REACT_APP_DOMAIN;
var loyaltyEndPoint = process.env.REACT_APP_LOYALTY;
var fasDetails = process.env.REACT_APP_FASFAS_DETAILS;
var defender = process.env.REACT_APP_DEFENDER_ENDPOINT;
var wac = process.env.REACT_APP_WAC_BASEPATH;
var kiron = process.env.REACT_APP_KIRON_BASEPATH;
var banner = process.env.REACT_APP_BANNERS;
var socket = process.env.REACT_APP_SOCKETURL;
var loyaltyUser = process.env.REACT_APP_BASIC_AUTH_USER;
var loyaltyPass = process.env.REACT_APP_BASIC_AUTH_PASS;
var vps = process.env.REACT_APP_VPS;
var gapbase = process.env.REACT_APP_GAP_BASEPATH;
var maxStake = process.env.REACT_APP_MAX_STAKE;
var cms_endpoint = process.env.REACT_APP_CMS_ENDPOINT;
var cmsUrl = process.env.REACT_APP_CMSURL;
var fasFasBrandId = process.env.REACT_APP_FASFAS_BRAND_ID;
var rgsEndPoint = process.env.REACT_APP_RGS_ENDPOINT;
var andromedaEndpoint = process.env.REACT_APP_ANDROMEDA_ENDPOINT;
var wacRgsEndpoint = process.env.REACT_APP_WAC_ENDPOINT;
var fasfasUserName = process.env.REACT_APP_FASFAS_USERNAME;
var fasfasPassword = process.env.REACT_APP_FASFAS_PASSWORD;
var rootGameLaunch = process.env.REACT_APP_ROOT_LAUNCH;
var rootGameLaunchKey = process.env.REACT_APP_ROOT_LAUNCH_TOKEN;
var vleagueEndPoint = process.env.REACT_APP_V_LEAGUE_BASEPATH;
var hub88_url = process.env.REACT_APP_HUB88_BASEPATH;
var lobbyPath = process.env.REACT_APP_LOBBY_PATH;
var depositPath = process.env.REACT_APP_DEPOSIT_PATH;
var howzzatUrl = process.env.REACT_APP_HOWZZAT_ENDPOINT;
var secretKey = process.env.REACT_APP_HASH_SECRET_KEY;
var chatbotApiEndpoint = process.env.REACT_APP_CHATBOT_API_ENDPOINT;
var lotteryLaunchUrl = process.env.REACT_APP_LOTTERY_LAUNCH_URL;
export const endpoints = {
  fasFasBrandId: fasFasBrandId,
  accountDetails: beEndPoint + "api/v1/player/details",
  footerStaticContent: cms_endpoint + "/footer",
  bottomMenuStaticContent: cms_endpoint + "/BottomMenu",
  topGamesListStaticContent: cms_endpoint + "/Topmenu",
  promotionStaticContent: cms_endpoint + "/offerlinkinfo",
  aboutStaticContent: cms_endpoint + "/otherlinkInfo",
  linkContent: cms_endpoint + "/otherlink",
  betHistory: beEndPoint + "api/v1/player/casino/bethistory",
  accountHistory: beEndPoint + "api/v1/player/new/accounthistory",
  cancelWithdraw: beEndPoint + "api/v1/cancel/withdraw",
  bonusHistory: beEndPoint + "v1/player/bonus/history",
  messageNotification: beEndPoint + "api/v1/player/notifications",
  markAllAsRead: beEndPoint + "api/v1/player/notifications/mark-all-as-read",
  markAsDelete: beEndPoint + "api/v1/player/notifications/mark-as-delete",
  accountDetails: beEndPoint + "api/v1/player/details",
  changePin: beEndPoint + "api/v1/player/change/password",
  logout: beEndPoint + "api/v1/player/logout",
  accountDetailsKYC: beEndPoint + "api/v1/player/upload/kyc",
  fasfasDetails: fasDetails,
  resetPin: beEndPoint + "api/v1/player/generate/otp",
  setnewPin: beEndPoint + "api/v1/player/verify/otp",
  signIn: beEndPoint + "api/v1/player/authenticate",
  registerOtp: beEndPoint + "api/v1/player/create/request/otp",
  verifySignUp: beEndPoint + "api/v1/register/otp",
  userDetails: beEndPoint + "api/v1/player/details",
  realBalance: beEndPoint + "api/v1/player/real/balance",
  affiliateRequest: beEndPoint + "api/v1/affiliate/approval/request",
  recentlyPlayedGamesList: beEndPoint + "api/v1/rgs/recent/game/data/user",
  affiliateData: beEndPoint + "api/v1/affiliate/summary",
  vipreport: beEndPoint + "api/btag",
  game_platform_id: 1,
  game_operater_id: "fasfas",
  wac_pn: "fasfas",
  defender_end_point: defender,
  hub88_basePath: hub88_url,
  wac_bace_path: wac,
  // wac_bace_path:"https://gpi.dev.watechnology.com/game.do",
  resGambling: beEndPoint + "api/v1/player/userlimits/update",
  kiron_basePath: kiron,
  deposit: beEndPoint + "api/v1/wallet/deposit",
  withdraw: beEndPoint + "api/v1/wallet/withdraw",
  loyalty: loyaltyEndPoint + "loyalty/updateUserLoyalty",
  userLoyalty: loyaltyEndPoint + "loyalty/getUserLoyalty",
  banners: banner,
  socketUrl: socket,
  redeemCoins: loyaltyEndPoint + "loyalty/redeemCoins",
  coinsHistory: loyaltyEndPoint + "loyalty/loyaltyHistory",
  vipgamesList: loyaltyEndPoint + "loyalty/updateGamesList",
  selectedGameList: loyaltyEndPoint + "loyalty/getGames",
  affiliateGames: loyaltyEndPoint + "loyalty/getAffiliateGames",
  affiliateUserName: loyaltyEndPoint + "loyalty/getUserByBTag",
  referralList: beEndPoint +"api/v1/player/referral/details",
  loyaltyUsername: loyaltyUser,
  loyaltyPassword: loyaltyPass,
  paymentConfig: beEndPoint + "api/v1/payment/config",
  allEarnings: beEndPoint + "api/affiliate/player/details/by/btag",
  password: "1234",
  payoutCycle: 0,
  role: "AGENT",
  setupCost: 50,
  commissionPercentage: 20,
  affiliatePin: "78334",
  channel: "Internet",
  penaltyShootout: vps,
  gapBasePath: gapbase,
  maxStakeAmount: maxStake,
  affiliateDetails: beEndPoint + "affiliate-details-by-btag",
  merchantid: "Fzj69WEy5mJLD0xOxyqXPu45SM5Y9CFj7C1",
  chatbotEndpoint: chatbotApiEndpoint + "/chatbot/chat",
  lotteryLaunchUrl: lotteryLaunchUrl,
  bonusUsage: beEndPoint + "v1/player/bonus",
  cms_endpoint: cms_endpoint + "/banner/" + fasFasBrandId,
  allCmsGmaes: cms_endpoint + "/Casino/" + fasFasBrandId,
  ezugipath: rgsEndPoint + "/rgs/api/ezugi/v2/getURL",
  andromeda: andromedaEndpoint,
  wacEndpoint: wacRgsEndpoint,
  fasfasuser: fasfasUserName,
  fasfasPass: fasfasPassword,
  rootGameLaunch: rootGameLaunch,
  rootGameLaunchToken: rootGameLaunchKey,
  vleague: vleagueEndPoint,
  lobbyUrlPath: lobbyPath,
  depositUrlPath: depositPath,
  howzzatPath: howzzatUrl,
  freespins: beEndPoint + "v1/player/free_spin/bonus",
  selfexclusion: beEndPoint + "api/v1/player/userlimits/update",
  hashMap: secretKey,
  encryption: beEndPoint + "api/encrypt?",
  casinoHistory: beEndPoint + "v1/player/casino/betHistory",
  casinoRoundHistory: beEndPoint + "v1/player/bethistory/casino/roundId",
  chatbotApiEndpoint: chatbotApiEndpoint+"/chatbot/chat",
};
